var $c018f81546b44eb3$exports = {};
let $c018f81546b44eb3$var$nav_timeout;
function $c018f81546b44eb3$var$show_nav() {
    document.querySelector('nav').classList.remove('hidden');
    document.querySelector('nav').classList.add('shown');
    if ($c018f81546b44eb3$var$nav_timeout) clearTimeout($c018f81546b44eb3$var$nav_timeout);
    $c018f81546b44eb3$var$nav_timeout = setTimeout($c018f81546b44eb3$var$hide_nav, 5000);
}
function $c018f81546b44eb3$var$hide_nav() {
    if (window.innerWidth > 576 || document.querySelector('nav').classList.contains('show')) {
        document.querySelector('nav').classList.remove('shown');
        document.querySelector('nav').classList.add('hidden');
    }
}
window.addEventListener('mousemove', $c018f81546b44eb3$var$show_nav);
$c018f81546b44eb3$var$show_nav();


//# sourceMappingURL=timeline.f3679a61.js.map
